import React from "react";
import { Redirect } from "react-router-dom";
import { Alert, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import {
  fetchPlaylistTracks,
  fetchPlaylist,
  putPlaylist,
  postPlaylist,
  deletePlaylist,
  postPlaylistTrack,
  deletePlaylistTracks,
} from "./services/DataService";
import DeleteAlert from "./components/DeleteAlert";
import "./style/form.scss";
import "./style/add-playlist.scss";

class AddPlaylist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      tracks: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onDeleteCallback = this.onDeleteCallback.bind(this);
    this.submitCallback = this.submitCallback.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      fetchPlaylist(this.props.match.params.id).then((playlist) => {
        fetchPlaylistTracks(playlist.id).then((tracks) => {
          tracks.forEach((track, i) => {
            tracks[i].durationminutes = Math.floor(track.duration / 60);
            tracks[i].durationseconds = track.duration % 60;
          });
          this.setState({
            playlist: playlist,
            name: playlist.name,
            tracks: tracks,
            loading: false,
          });
        });
      });
    } else {
      this.setState({
        loading: false,
        tracks: [{ name: "", artist: "", album: "", label: "", duration: 0 }],
      });
    }
  }

  submitCallback(id) {
    let newID = id ? id : this.state.id;
    this.setState({
      id: newID,
      alert: (
        <Alert variant="secondary">
          <Alert.Heading>Submission Successful</Alert.Heading>
          <hr />
          <p>The playlist has been added/updated.</p>
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => this.setState({ redirect: "/playlists" })}
              variant="outline-secondary"
            >
              Close
            </Button>
          </div>
        </Alert>
      ),
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    this.setState({ validated: true });
    var isValid = form.checkValidity();
    let playlist = {
      name: this.state.name,
    };
    if (isValid) {
      if (this.props.match.params.id) {
        playlist.ID = parseInt(this.props.match.params.id, 10);
        putPlaylist(playlist).then(this.submitPlaylistCallback);
      } else {
        postPlaylist(playlist).then(this.submitPlaylistCallback);
      }
    }
  };

  submitPlaylistCallback = (id) => {
    if (this.props.match.params.id) {
      deletePlaylistTracks(id).then(() => {
        this.state.tracks.forEach((track, i) => {
          track.position = i + 1;
          track.duration =
            parseInt(track.durationminutes) * 60 +
            parseInt(track.durationseconds);
          postPlaylistTrack(id, track).then(() => {});
        });
      });
    } else {
      this.state.tracks.forEach((track, i) => {
        track.position = i + 1;
        track.duration =
          parseInt(track.durationminutes) * 60 +
          parseInt(track.durationseconds);
        postPlaylistTrack(id, track).then(() => {});
      });
    }
    setTimeout(() => {
      this.submitCallback(id);
    }, 1000);
  };

  onDelete() {
    this.setState({ deleteAlert: true });
  }

  onDeleteCallback() {
    this.setState({ deleteAlert: false, redirect: "/playlists" });
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  onChangeTrack = (i, e) => {
    let tracks = this.state.tracks;
    if (e.target.name === "durationseconds" && e.target.value !== "") {
      let sec = "";
      if (!isNaN(e.target.value)) {
        sec = parseInt(e.target.value);
        if (sec > 59) {
          sec = 59;
        }
      }
      e.target.value = sec;
    }
    if (e.target.name === "durationminutes" && e.target.value !== "") {
      let min = "";
      if (!isNaN(e.target.value)) {
        min = parseInt(e.target.value);
        if (min > 120) {
          min = 120;
        }
      }
      e.target.value = min;
    }
    tracks[i][e.target.name] = e.target.value;
    this.setState({ tracks: tracks });
  };

  addTrack = () => {
    let tracks = this.state.tracks;
    tracks.push({ name: "", artist: "", album: "", label: "", duration: 0 });
    this.setState({ tracks: tracks });
  };

  removeTrack = (i) => {
    let tracks = this.state.tracks;
    tracks.splice(i, 1);
    this.setState({ tracks: tracks });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.alert) {
      return this.state.alert;
    }
    let deleteAlert;
    if (this.state.deleteAlert) {
      deleteAlert = (
        <DeleteAlert
          onConfirm={() => {
            deletePlaylist(this.props.match.params.id).then(
              this.onDeleteCallback
            );
          }}
          onCancel={() => this.setState({ deleteAlert: false })}
        />
      );
    }
    let deleteButton;
    if (this.props.match.params.id) {
      deleteButton = (
        <div className="d-flex justify-content-center">
          <Button
            variant="danger"
            className="btn-delete"
            onClick={this.onDelete}
          >
            Delete
          </Button>
        </div>
      );
    }
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" className="kugs-spinner">
          <span className="sr-only">Loading...</span>
        </Spinner>
      );
    }
    return (
      <div>
        {deleteAlert}
        <div className="form-title">
          {this.props.match.params.id ? "Edit" : "Add"} a Playlist
        </div>
        <Form
          className="form"
          noValidate
          validated={this.state.validated}
          onSubmit={this.handleSubmit}
        >
          <Form.Group as={Row}>
            <Form.Label column sm="3">
              Name
            </Form.Label>
            <Col sm="9">
              <Form.Control
                required
                type="text"
                name="name"
                onChange={this.onChange}
                value={this.state.name || ""}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a name.
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm="12">
              Tracks
            </Form.Label>
          </Form.Group>
          {this.state.tracks.map((track, i) => {
            return (
              <Form.Group as={Row} key={i} className="pt-2 pb-2">
                <Col sm="1">
                  <div className="index">{i + 1}</div>
                </Col>
                <Form.Label column sm="1">
                  Artist
                </Form.Label>
                <Col sm="3">
                  <Form.Control
                    size="sm"
                    type="text"
                    name="artist"
                    onChange={(e) => this.onChangeTrack(i, e)}
                    value={track.artist || ""}
                  />
                </Col>
                <Form.Label column sm="1">
                  Song
                </Form.Label>
                <Col sm="3">
                  <Form.Control
                    size="sm"
                    type="text"
                    name="name"
                    onChange={(e) => this.onChangeTrack(i, e)}
                    value={track.name || ""}
                  />
                </Col>
                <Form.Label column sm="1">
                  Album
                </Form.Label>
                <Col sm="2">
                  <Form.Control
                    size="sm"
                    type="text"
                    name="album"
                    onChange={(e) => this.onChangeTrack(i, e)}
                    value={track.album || ""}
                  />
                </Col>
                <Col sm="1"></Col>
                <Form.Label column sm="1">
                  Label
                </Form.Label>
                <Col sm="3">
                  <Form.Control
                    size="sm"
                    type="text"
                    name="label"
                    onChange={(e) => this.onChangeTrack(i, e)}
                    value={track.label || ""}
                  />
                </Col>
                <Form.Label column sm="1">
                  Duration
                </Form.Label>
                <Col sm="1">
                  <Form.Control
                    size="sm"
                    type="text"
                    name="durationminutes"
                    pattern="[0-9]*"
                    autoComplete="off"
                    onChange={(e) => this.onChangeTrack(i, e)}
                    value={track.durationminutes || ""}
                  />
                </Col>
                :
                <Col sm="1">
                  <Form.Control
                    size="sm"
                    type="text"
                    name="durationseconds"
                    pattern="[0-9]{1,2}"
                    autoComplete="off"
                    onChange={(e) => this.onChangeTrack(i, e)}
                    value={track.durationseconds || ""}
                  />
                </Col>
                <Col>
                  <Button
                    variant="primary"
                    onClick={() => {
                      this.removeTrack(i);
                    }}
                    className="glyphicon glyphicon-minus btn-add btn-remove"
                  >
                    <div className="hidden">Remove</div>
                  </Button>
                </Col>
              </Form.Group>
            );
          })}
          <Row>
            <Col sm="12" className="d-flex justify-content-center">
              <Button
                variant="primary"
                onClick={this.addTrack}
                className="glyphicon glyphicon-plus btn-add d-flex justify-content-center"
              >
                <div className="hidden">Add</div>
              </Button>
            </Col>
          </Row>
          <div className="d-flex justify-content-center btn-container">
            <Button variant="primary" type="submit" className="btn-submit">
              {this.props.match.params.id ? "Update" : "Add"}
            </Button>
            {deleteButton}
          </div>
        </Form>
      </div>
    );
  }
}

export default AddPlaylist;
